// extracted by mini-css-extract-plugin
module.exports = {"feedback":"style_feedback__emnUl"};